import {inject, Injectable} from '@angular/core';
import {map, Observable} from "rxjs";
import {HttpClient} from "@angular/common/http";
import {ClientService} from "../auth/client.service";
import {environment} from "../../../environments/environment";
import {IConversation} from "../../models/conversation.model";

@Injectable({
  providedIn: 'root'
})
export class MasterThreadService {
    protected http = inject(HttpClient);
    protected clientService = inject(ClientService);


  protected api = '/master-threads/'; // Base URL for the client API
  protected getEndpoint(): string {
    return environment.aiBaseServerUrl + this.clientService.client?.id + this.api
  }


  public getMasterThreadAsync(id: string): Observable<IConversation> {
    return this.http.get<IConversation>(this.getEndpoint() + id);
  }

  public getAttachment(conversationId: string, messageId: string, attachmentId: string): Observable<Blob> {
    const clientId = this.clientService.client?.id;
    const parts = [conversationId, 'messages', messageId, 'attachments', attachmentId].map(encodeURIComponent);
    return this.http.get(this.getEndpoint() + parts.join('/'), {responseType: 'blob'}).pipe(map(blob => {
      if (!clientId || clientId !== this.clientService.client?.id) throw new Error('Conversation scope changed');
      return blob;
    }));
  }

  public getMasterThreadsAsync(): Observable<IConversation[]> {
    return this.http.get<IConversation[]>(this.getEndpoint());
  }

  public saveMasterThreadAsync(obj: IConversation): Observable<void> {
    return this.http.post<void>(this.getEndpoint(), obj);
  }

  public getMasterThreadsForChatbotAsync(chatbotId: string, limit: number = 100): Observable<IConversation[]> {
    return this.http.get<IConversation[]>(this.getEndpoint() + 'chatbot/' + chatbotId + '?limit=' + limit);
  }

  public approveMasterThreadAsync(id: string, obj: IConversation): Observable<IConversation> {
    return this.http.patch<IConversation>(this.getEndpoint() + id + '/approve/', obj);
  }

  public declineMasterThreadAsync(id: string, obj: IConversation): Observable<IConversation> {
    return this.http.patch<IConversation>(this.getEndpoint() + id + '/decline/', obj);
  }

  public deleteMasterThreadAsync(id: string): Observable<void> {
    return this.http.delete<void>(this.getEndpoint() + id + '/');
  }
}
